import React, {PureComponent} from 'react';
import Header from '../Header';
import ReactPixel from 'react-facebook-pixel';
import ReactGA from 'react-ga';

export default class SubscriptionConfirmation extends PureComponent {
    state = {
        counter: 5
    }

    componentDidMount() {

        //  console.log('GA active')
        // ReactGA.pageview(window.location.pathname + window.location.search);


        let counter = 5;
        let interval = setInterval(() => {
            counter--;
            this.setState({counter})
            if (counter === 0) {
                clearInterval(interval);
                if (this.props.navigateBackTo) {
                    window.location.href = this.props.navigateBackTo
                } else {
                    this.props.history.push('/channels', 'subscription-done');
                }

            }
        }, 1000);
        if (process.env.REACT_APP_ENVIRONMENT === 'PROD') {
            if (window.location.pathname === '/subscription-confirmation') {
                ReactPixel.track('Purchase - Default');
            } else if (window.location.pathname === '/free-confirmation') {
                ReactPixel.track('Purchase - Free');
                ReactGA.event({
                    category: 'free plan',
                    action: 'submit',
                    label: '',
                    nonInteraction: true
                });
            } else if (window.location.pathname === '/essentials-monthly-confirmation') {
                ReactPixel.track('Purchase - Essentials Monthly');
                ReactGA.event({
                    category: 'essentials monthly plan',
                    action: 'purchased',
                    label: '',
                    nonInteraction: true
                });
            } else if (window.location.pathname === '/boost-monthly-confirmation') {
                ReactPixel.track('Purchase - Boost Monthly');
                ReactGA.event({
                    category: 'boost monthly plan',
                    action: 'purchased',
                    label: '',
                    nonInteraction: true
                });
            } else if (window.location.pathname === '/essentials-yearly-confirmation') {
                ReactPixel.track('Purchase - Essentials Yearly');
                ReactGA.event({
                    category: 'essentials yearly plan',
                    action: 'purchased',
                    label: '',
                    nonInteraction: true
                });
            } else if (window.location.pathname === '/boost-yearly-confirmation') {
                ReactPixel.track('Purchase - Boost Yearly');
                ReactGA.event({
                    category: 'boost yearly plan',
                    action: 'purchased',
                    label: '',
                    nonInteraction: true
                });
            } else if (window.location.pathname === '/martech-ltd-success') {
                ReactPixel.track('Purchase - Martech');
            }
        }
    }

    componentDidUpdate = () => {
    }

    render() {
        return (
            <div className='onboarding-container'>
                <Header linkDisabled={true}/>
                <div className="onboarding-content">
                    <div className="thank-you-panel">
                        <h1 className="text-align-center">Thank You!</h1>
                        <img className='big-rocket' src="/img/rocket.gif" alt=""/>
                        {this.props.version2 ?
                            <p className='blue'>Please check your email for additional details.</p>
                            :
                            <p className='blue'>You're good to go!</p>
                        }
                        <p className='normal margin-top-20 margin-bottom-30'>Your order was completed successfully.</p>
                        {this.props.version2 ?
                            <p className='grey'>You will be redirected to the previous page</p>
                            :
                            <p className='grey'>You will be redirected to your new account
                                in... {this.state.counter}</p>
                        }
                        {
                            this.props.navigateBackTo ?
                                <a className='grey' href={this.props.navigateBackTo}>Or click here to proceed now</a>
                                :
                                <a className='grey'
                                   onClick={() => this.props.history.push('/channels', 'subscription-done')} href='#'>Or
                                    click here to proceed now</a>
                        }

                    </div>
                </div>
            </div>
        )
    }
}